import { render, staticRenderFns } from "./TitlemaxSidebar.vue?vue&type=template&id=3bd669ad"
import script from "./TitlemaxSidebar.vue?vue&type=script&lang=js"
export * from "./TitlemaxSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports